
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableRT(): TemplateResult<fitmentTableRTRootProps> {
    function repeatAlwaysVisibleValues1(alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'cm_fitment-table_item' }, this.fitment.Make ? _createElement('div', mergeProps({
                    'className': 'cm_fitment-table_make',
                    'key': '51'
                }, { dangerouslySetInnerHTML: { __html: typeof this.fitment.Make === 'undefined' ? '' : this.fitment.Make } })) : null, _createElement('div', { 'className': 'cm_fitment-table_entry' }, this.fitment.Model ? _createElement('span', mergeProps({
                    'className': 'cm_fitment-table_model',
                    'key': '308'
                }, { dangerouslySetInnerHTML: { __html: typeof this.fitment.Model === 'undefined' ? '' : this.fitment.Model } })) : null, this.fitment.Year ? _createElement('span', mergeProps({
                    'className': 'cm_fitment-table_year',
                    'key': '525'
                }, { dangerouslySetInnerHTML: { __html: typeof Array.isArray(this.fitment.Year) ? this.fitment.Year.join(', ') : this.fitment.Year === 'undefined' ? '' : Array.isArray(this.fitment.Year) ? this.fitment.Year.join(', ') : this.fitment.Year } })) : null));
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues2(initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'cm_fitment-table_item' }, this.fitment.Make ? _createElement('div', mergeProps({
                    'className': 'cm_fitment-table_make',
                    'key': '55'
                }, { dangerouslySetInnerHTML: { __html: typeof this.fitment.Make === 'undefined' ? '' : this.fitment.Make } })) : null, _createElement('div', { 'className': 'cm_fitment-table_entry' }, this.fitment.Model ? _createElement('span', mergeProps({
                    'className': 'cm_fitment-table_model',
                    'key': '316'
                }, { dangerouslySetInnerHTML: { __html: typeof this.fitment.Model === 'undefined' ? '' : this.fitment.Model } })) : null, this.fitment.Year ? _createElement('span', mergeProps({
                    'className': 'cm_fitment-table_year',
                    'key': '535'
                }, { dangerouslySetInnerHTML: { __html: typeof Array.isArray(this.fitment.Year) ? this.fitment.Year.join(', ') : this.fitment.Year === 'undefined' ? '' : Array.isArray(this.fitment.Year) ? this.fitment.Year.join(', ') : this.fitment.Year } })) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_fitment-table fitment-table-container' }, this.vehicleSpecific ? _createElement('div', {
        'className': 'fitment-table-title vehicle-specific',
        'key': '58'
    }, '\n    ', _translate(`fitment_table_vehicle_specific`), '\n  ') : null, this.noFitmentData ? _createElement('div', {
        'className': 'fitment-table-title no-fitment-data',
        'key': '201'
    }, '\n    ', window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`), _createElement('br', {}), window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`), '\n  ') : null, this.universalFit ? _createElement('div', {
        'className': 'fitment-table-title universal-fit',
        'key': '469'
    }, '\n    ', window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || _translate(`fitment_universal_title`), _createElement('br', {}), window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || _translate(`fitment_universal_text`), '\n  ') : null, this.manyFitments ? _createElement('div', {
        'className': 'fitment-table-title many-fitments',
        'key': '853'
    }, '\n    ', _translate(`fitment_table_many_fitments`), '\n  ') : null, this.vehicleSpecific || this.manyFitments ? [
        _createElement.apply(this, [
            'div',
            {
                'className': 'cm_fitment-table_values cmRepeater_alwaysVisibleValues',
                'key': '9881'
            },
            _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues1.bind(this))
        ]),
        this.initiallyHiddenValues?.length ? _createElement('div', {
            'className': 'cm_collapsible-elem',
            'key': '9883'
        }, _createElement.apply(this, [
            'div',
            { 'className': 'cm_fitment-table_values cmRepeater_initiallyHiddenValues' },
            _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues2.bind(this))
        ])) : null
    ] : null, this.initiallyHiddenValues?.length ? _createElement('div', {
        'className': 'cm_fitment-table_collapse-button-container',
        'key': '4921'
    }, _createElement('button', {
        'className': 'cm_fitment-table_collapse-button cm_button button-primary',
        'onClick': this.toggleCollapsed
    }, this.isCollapsed ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.isCollapsed ? [_translate(`show_less`)] : null)) : null);
}
        export const componentNames = []